
export type RequestType = typeof RequestType[keyof typeof RequestType];


export const RequestType = {
  Doka360: 'Doka360',
  NonDoka360: 'NonDoka360',
} as const;
